var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 d-flex flex-column",style:('height:'+_vm.$store.getters['general/availableHeight']+'px;'),attrs:{"fluid":""}},[_c('OnlyOfficeEditor',{attrs:{"documentId":_vm.documentId,"height":_vm.$store.getters['general/availableHeight']+'px',"mode":'edit'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }